'use strict';

/**
 * Get cookie value by cookie name from browser
 * @param {string} cookieName - name of the cookie
 * @returns {string} cookie value of the found cookie name
 */
function getCookie(cookieName) {
    var name = cookieName + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === ' ') {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return '';
}

/**
 * Sets cookie value by cookie name from browser
 * @param {string} cookieName - name of the cookie
 * @param {string} cookieValue - value of the cookie
 * @param {integer} seconds - cookie's length of seconds to be valid
 */
function createCookie(cookieName, cookieValue, seconds) {
    let expires = '0';

    if (seconds) {
        var date = new Date();
        date.setTime(date.getTime() + parseInt(seconds, 10) * 1000);
        expires = '; expires=' + date.toGMTString();
    }

    document.cookie = cookieName + '=' + cookieValue + expires + '; path=/';
}

module.exports = {
    getCookie: getCookie,
    createCookie: createCookie
};
